import {
  AgxButton,
  AgxDivider,
  AgxSpacer,
  AgxTypography,
  Icon_Arrow,
  Breakpoints,
  useWindowSize,
} from '@urbanx/agx.ui-components2';

interface Props {
  id: string;
  title: string;
  saving: boolean;
  disabled: boolean;
  onSave(): void;
  onBack?: () => void;
}

export default function SettingsPageHeader({ id, title, saving, disabled, onSave, onBack }: Props) {
  const windowSize = useWindowSize();
  return (
    <AgxSpacer gap="spacing-xl">
      <AgxSpacer
        direction="horizontal"
        contentJustification="space-between"
        contentAlignment="center"
        gap="spacing-lg"
        wrap
      >
        {windowSize !== Breakpoints.Desktop && onBack ? (
          <AgxButton
            id={`${id}-back`}
            text={title}
            variant="naked"
            size="large"
            leftIcon={<Icon_Arrow direction="left" width={22} height={22} color="currentColor" />}
            onClick={onBack}
          />
        ) : (
          <AgxTypography
            id="settings-title"
            type="label"
            size="large"
            role="heading"
            aria-level={1}
          >
            Settings
          </AgxTypography>
        )}
        <AgxButton
          id={`save-${id}`}
          text={saving ? 'Saving…' : 'Save Changes'}
          variant="primary"
          size="medium"
          disabled={disabled}
          onClick={onSave}
        />
      </AgxSpacer>
      <AgxDivider variant="horizontal" />
    </AgxSpacer>
  );
}
